import { createSelector } from 'reselect';
import { Dictionary } from 'lodash';
import { State } from 'reducers';

const emptyArray = Object.freeze([]);

const getDeviceTypesState =
    (state: State) =>
        state.deviceTypes;

export const getDeviceTypes =
    createSelector(getDeviceTypesState,
        state => state.data
    );

export const getDeviceTypeOrder =
    createSelector(getDeviceTypes,
        types => {
            if (!types) return emptyArray;
            return Object.keys(types)
                .sort((a, b) => types[a].displayName.localeCompare(types[b].displayName));
        }
    );

const emptyLookup = {};
export const getDeviceTypeNamesLookup =
    createSelector(getDeviceTypes,
        deviceTypes => {
            if (!deviceTypes) return emptyLookup;
            const lookup: Dictionary<string> = {};
            Object.keys(deviceTypes).forEach(id => {
                lookup[id] = deviceTypes[id].displayName;
            });
            return lookup;
        }
    );

// TODO: could change this to take into account how long ago deviceTypes were loaded
export const isDeviceTypesLoaded =
    createSelector(getDeviceTypesState,
        state => state.loaded
    );

const getDeviceTypeId = (state: State, { deviceTypeId }: Partial<{ deviceTypeId: string | null }>) => deviceTypeId;

export const getDeviceType =
    createSelector(
        getDeviceTypes,
        getDeviceTypeId,
        (deviceTypes, id) => (deviceTypes && id && deviceTypes[id]) || null
    );

export const getDeviceTypesError =
    createSelector(getDeviceTypesState,
        state => state.error
    );

export const getIsLoadingDeviceTypes =
    createSelector(getDeviceTypesState,
        state => state.loading
    );
